// ============================================================
// imagem.js — ler e reduzir a foto que alguém escolheu no aparelho
//
// Duas telas sobem foto de atleta: o cadastro facial, que manda a imagem de
// referência do reconhecimento, e o cadastro geral, que manda o retrato de
// uniforme. As duas precisam exatamente do mesmo preparo antes do envio, e
// uma cópia em cada arquivo é uma cópia que diverge no dia em que alguém
// muda o lado máximo numa delas.
//
// São duas FOTOS diferentes, de propósito, mas um preparo só.
// ============================================================

// Uma foto de celular moderno tem 4 MB e 4000 pixels de largura. O
// reconhecimento não usa nada disso e a lista mostra o retrato em menos de
// 200 pixels: o excesso só deixa o envio lento na rede do núcleo, que é a
// rede de onde a coordenação cadastra.
export const LADO_MAXIMO = 900;

export function reduzirImagem(origem, tipoSaida = "image/jpeg", ladoMaximo = LADO_MAXIMO) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const escala = Math.min(1, ladoMaximo / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * escala);
      canvas.height = Math.round(img.height * escala);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL(tipoSaida, 0.9));
    };
    img.onerror = () => reject(new Error("Não foi possível ler a imagem."));
    img.src = origem;
  });
}

export function lerArquivoComoDataUrl(file) {
  return new Promise((resolve, reject) => {
    const leitor = new FileReader();
    leitor.onload = () => resolve(leitor.result);
    leitor.onerror = () => reject(new Error("Não foi possível ler o arquivo."));
    leitor.readAsDataURL(file);
  });
}

// Separa o "data:image/jpeg;base64,xxxx" nas duas partes que o servidor
// espera. Estava escrito à mão em cada chamada, e cada uma recortava a
// string de um jeito.
export function partesDoDataUrl(dataUrl) {
  const texto = String(dataUrl || "");
  const virgula = texto.indexOf(",");
  if (virgula < 0) return { base64: texto, tipo: "image/jpeg" };
  const cabecalho = texto.slice(0, virgula);
  const tipo = (cabecalho.match(/data:([^;]+)/) || [])[1] || "image/jpeg";
  return { base64: texto.slice(virgula + 1), tipo };
}
